export default __webpack_public_path__ + "images/c81db26c717af8221a3f415937f9d8a6.svg";